<template>
  <div style="padding: 20px;">
    <!-- 搜索条件 -->
    <div>
      <el-select v-model="parmrs.department_id" filterable placeholder="请选择部门" @change="newqwr">
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>

      <el-select
        v-model="parmrs.pitcher_id"
        :disabled="parmrs.department_id === ''"
        filterable
        placeholder="请选择投手"
        style="margin-left: 20px;"
      >
        <el-option v-for="item in optionstwo" :key="item.id" :label="item.admin_name" :value="item.id" />
      </el-select>

      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 300px;margin-left: 20px;"
        @change="handleDateChange"
      />

      <el-input v-model="parmrs.account_name" placeholder="广告主名称" style="width: 260px;margin-left: 20px;" />
      <el-input v-model="parmrs.account_id" placeholder="广告主ID" style="width: 220px;margin-left: 20px;" />

      <el-button type="primary" icon="el-icon-search" style="margin-left: 20px;" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
    </div>

    <!-- IAA 投手报表 -->
    <div style="margin-top: 40px;">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
        <h3 style="margin: 0;">IAA投手报表</h3>
        <!-- <el-button type="default" icon="el-icon-setting" @click="openPitcherColumnConfig">列配置</el-button> -->
      </div>

      <el-card shadow="never" class="summary-card">
        <div class="summary-container">
          <div v-for="(v,k) in summaryMap" :key="k" class="summary-item">
            <div class="summary-label">{{ v.label }}</div>
            <div class="summary-value">{{ reportData[v.key] || 0 }}</div>
          </div>
        </div>
      </el-card>

      <el-table
        v-loading="loading2"
        :data="pitcherSortedTableData"
        border
        row-key="id"
        style="width: 100%;margin-top: 20px;"
        @sort-change="sortChange2"
      >
        <!-- 固定列：默认展示，不可隐藏 -->
        <el-table-column prop="pitcher_name" label="投手名称" align="center" sortable="custom" />
        <el-table-column prop="department_name" label="部门名称" align="center" sortable="custom" />
        <el-table-column prop="account_num" label="广告主数量" align="center" sortable="custom" />
        <el-table-column prop="cost" label="消耗（元）" align="center" sortable="custom" />
        <!-- 可选列：根据配置显示 -->
        <el-table-column
          v-for="col in visiblePitcherOptionalColumns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          align="center"
          sortable="custom"
        />
      </el-table>
    </div>

    <!-- IAA 回收报表 -->
    <div style="margin-top: 30px;">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
        <h3 style="margin: 0;">IAA回收报表</h3>
        <el-button type="default" icon="el-icon-setting" @click="openColumnConfig">列配置</el-button>
      </div>

      <el-table
        v-loading="loading1"
        :data="tableData1"
        border
        stripe
        row-key="id"
        style="width: 100%;"
        @sort-change="sortChange1"
      >
        <!-- 固定列：默认展示 -->
        <el-table-column prop="stat_date" label="日期" align="center" />
        <el-table-column prop="advertiser_id" label="广告主ID" align="center" />
        <el-table-column prop="advertiser_name" width="200" label="广告主名称" align="center" />
        <el-table-column prop="pitcher_name" label="投手名称" align="center" />
        <el-table-column prop="department_name" label="部门名称" align="center" />
        <!-- 可选列：根据配置显示 -->
        <el-table-column
          v-for="col in visibleOptionalColumns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :sortable="col.sortable || false"
          :formatter="col.formatter"
          align="center"
        />
      </el-table>

      <!-- 回收报表列配置弹框 -->
      <el-dialog
        title="列显示配置"
        :visible.sync="columnConfigVisible"
        width="1200px"
        append-to-body
      >
        <div class="column-config-list">
          <el-checkbox
            v-for="col in optionalColumnsConfig"
            :key="col.prop"
            v-model="columnConfigTemp[col.prop]"
          >
            {{ col.label }}
          </el-checkbox>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="columnConfigVisible = false">取消</el-button>
          <el-button type="primary" @click="applyColumnConfig">确定</el-button>
        </span>
      </el-dialog>

      <!-- 投手报表列配置弹框 -->
      <el-dialog
        title="投手报表列配置"
        :visible.sync="pitcherColumnConfigVisible"
        width="800px"
        append-to-body
      >
        <div class="column-config-list">
          <el-checkbox
            v-for="col in pitcherOptionalColumnsConfig"
            :key="col.prop"
            v-model="pitcherColumnConfigTemp[col.prop]"
          >
            {{ col.label }}
          </el-checkbox>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="pitcherColumnConfigVisible = false">取消</el-button>
          <el-button type="primary" @click="applyPitcherColumnConfig">确定</el-button>
        </span>
      </el-dialog>

      <pagination-right
        :current-page="parmrs.page"
        :page-sizes="[10]"
        :total="total1"
        @current-change="fetchCurrentPage1"
        @size-change="fetchPageSize1"
      />
    </div>
  </div>
</template>

<script>
import {
  iaaMaterialReportdepartmentlist,
  iaapitcherindex,
  reportrecyclingList,
  reportpitcherList
} from '@/api/TKreleaseGroup'
import PaginationRight from '@/components/PaginationRight'

// 回收报表可选列配置
const OPTIONAL_COLUMNS = [
  { prop: 'stat_cost', label: '消耗', sortable: 'custom' },
  { prop: 'ctr', label: '点击率', sortable: 'custom', formatter: (row, col, val) => val != null ? val + '%' : '' },
  { prop: 'conversion_cost', sortable: 'custom', label: '平均转化成本' },
  { prop: 'conversion_rate', sortable: 'custom', label: '转化率', formatter: (row, col, val) => val != null ? val + '%' : '' },
  { prop: 'cpc_platform', sortable: 'custom', label: '平均点击单价(元)' },
  { prop: 'cpm_platform', sortable: 'custom', label: '平均千次展现费用(元)' },
  { prop: 'attribution_game_in_app_ltv_1day', sortable: 'custom', label: '当日付费金额' },
  { prop: 'attribution_game_in_app_roi_1day', sortable: 'custom', label: '当日付费ROI' },
  { prop: 'attribution_game_in_app_ltv_2days', sortable: 'custom', label: '激活后一日付费金额' },
  { prop: 'attribution_game_in_app_ltv_3days', sortable: 'custom', label: '激活后三日付费金额' },
  { prop: 'attribution_game_in_app_ltv_7days', sortable: 'custom', label: '激活后七日付费金额' },
  { prop: 'attribution_game_in_app_roi_2days', sortable: 'custom', label: '激活后一日付费ROI' },
  { prop: 'attribution_game_in_app_roi_3days', sortable: 'custom', label: '激活后三日付费ROI' },
  { prop: 'attribution_game_in_app_roi_7days', sortable: 'custom', label: '激活后七日付费ROI' },
  { prop: 'valid_play_rate', sortable: 'custom', label: '有效播放率', formatter: (row, col, val) => val != null ? val + '%' : '' },
  { prop: 'attribution_deep_convert_rate', label: '深度转化率', formatter: (row, col, val) => val != null ? val + '%' : '' },
  { prop: 'play_over_rate', label: '完播率', formatter: (row, col, val) => val != null ? val + '%' : '' },
  { prop: 'wifi_play_rate', label: 'WiFi播放占比', formatter: (row, col, val) => val != null ? val + '%' : '' },
  { prop: 'show_cnt', label: '展示数' },
  { prop: 'click_cnt', label: '点击数' },
  { prop: 'convert_cnt', label: '转化数' },
  { prop: 'deep_convert_cnt', label: '深度转化数' },
  { prop: 'total_play', label: '播放量' },
  { prop: 'valid_play', label: '有效播放数' },
  { prop: 'valid_play_of_mille', label: '千次有效播放数' },
  { prop: 'play_25_feed_break', label: '25%进度播放数' },
  { prop: 'play_50_feed_break', label: '50%进度播放数' },
  { prop: 'play_75_feed_break', label: '75%进度播放数' },
  { prop: 'play_99_feed_break', label: '99%进度播放数' },
  { prop: 'card_show', label: '3秒卡片展现数' },
  { prop: 'dy_like', label: '点赞数' },
  { prop: 'dy_comment', label: '评论量' },
  { prop: 'average_play_time_per_play', label: '平均单次播放时长' },
  { prop: 'valid_play_cost', label: '有效播放成本' },
  { prop: 'deep_convert_cost', label: '深度转化成本' },
  { prop: 'valid_play_cost_of_mille', label: '千次有效播放成本' },
  { prop: 'attribution_micro_game_0d_ltv', label: '小程序/小游戏当日LTV' },
  { prop: 'attribution_micro_game_3d_ltv', label: '小程序/小游戏激活后三日LTV' },
  { prop: 'attribution_micro_game_7d_ltv', label: '小程序/小游戏激活后七日LTV' },
  { prop: 'attribution_micro_game_0d_roi', label: '小程序/小游戏当日广告变现ROI' },
  { prop: 'attribution_micro_game_3d_roi', label: '小程序/小游戏激活后三日广告变现ROI' },
  { prop: 'attribution_micro_game_7d_roi', label: '小程序/小游戏激活后七日广告变现ROI' }
]

// 投手报表可选列配置
const PITCHER_OPTIONAL_COLUMNS = [
  { prop: 'income', label: '回收' },
  // { prop: 'rebate_income', label: '扣点回收' },
  // { prop: 'start_date', label: '开始时间' },
  // { prop: 'end_date', label: '结束时间' },
  // { prop: 'rebate_roi', label: '扣点回收ROI' },
  // { prop: 'income_roi', label: '回收ROI' },
  { prop: 'roi', label: 'ROI' },
  { prop: 'profit', label: '利润' },
  // { prop: 'rebate_profit', label: '扣点利润' },
  { prop: 'income_0d', label: '首日回收' },
  // { prop: 'rebate_income_0d', label: '首日扣点回收' },
  { prop: 'income_3d', label: '3日回收' },
  // { prop: 'rebate_income_3d', label: '3日扣点回收' },
  { prop: 'income_7d', label: '7日回收' }
  // { prop: 'rebate_income_7d', label: '7日扣点回收' }
]

// 存储key区分开，互不影响
const COLUMN_CONFIG_STORAGE_KEY = 'iaa_report_column_config'
const PITCHER_COLUMN_CONFIG_STORAGE_KEY = 'iaa_pitcher_report_column_config'

// 回收报表默认配置
function getDefaultColumnConfig() {
  const defaultHiddenProps = ['wifi_play_rate', 'play_25_feed_break', 'play_50_feed_break', 'play_75_feed_break', 'play_99_feed_break']
  const checked = {}
  OPTIONAL_COLUMNS.forEach(col => {
    checked[col.prop] = !defaultHiddenProps.includes(col.prop)
  })
  return checked
}

// 投手报表默认配置（默认全部显示）
function getDefaultPitcherColumnConfig() {
  const defaultHiddenProps = ['income_roi', 'roi', 'profit', 'income', 'start_date', 'end_date', 'income_0d', 'income_3d', 'income_7d']
  const checked = {}
  PITCHER_OPTIONAL_COLUMNS.forEach(col => {
    checked[col.prop] = defaultHiddenProps.includes(col.prop)
  })
  return checked
}

// 加载回收报表列配置
function loadColumnConfigFromStorage() {
  try {
    const saved = localStorage.getItem(COLUMN_CONFIG_STORAGE_KEY)
    if (saved) {
      const parsed = JSON.parse(saved)
      const result = getDefaultColumnConfig()
      OPTIONAL_COLUMNS.forEach(col => {
        if (Object.prototype.hasOwnProperty.call(parsed, col.prop)) {
          result[col.prop] = !!parsed[col.prop]
        }
      })
      return result
    }
  } catch (e) {
    console.log(e)
  }
  return getDefaultColumnConfig()
}

// 加载投手报表列配置
function loadPitcherColumnConfigFromStorage() {
  try {
    const saved = localStorage.getItem(PITCHER_COLUMN_CONFIG_STORAGE_KEY)
    if (saved) {
      const parsed = JSON.parse(saved)
      const result = getDefaultPitcherColumnConfig()
      PITCHER_OPTIONAL_COLUMNS.forEach(col => {
        if (Object.prototype.hasOwnProperty.call(parsed, col.prop)) {
          result[col.prop] = parsed[col.prop]
        }
      })
      return result
    }
  } catch (e) {
    console.log(e)
  }
  return getDefaultPitcherColumnConfig()
}

export default {
  components: { PaginationRight },
  data() {
    const optionalColumnsConfig = OPTIONAL_COLUMNS
    const pitcherOptionalColumnsConfig = PITCHER_OPTIONAL_COLUMNS
    const columnConfigChecked = loadColumnConfigFromStorage()
    const pitcherColumnConfigChecked = loadPitcherColumnConfigFromStorage()
    return {
      options: [],
      optionstwo: [],
      dateRange: [],
      parmrs: {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: '',
        account_id: '',
        account_name: '',
        start_time: '',
        end_time: ''
      },
      tableData1: [],
      tableData2: [],
      total1: 0,
      loading1: false,
      loading2: false,
      order_by: null,
      // 投手排序参数
      pitcherSort: {
        prop: '',
        order: ''
      },
      reportData: {},
      // 回收报表配置
      optionalColumnsConfig,
      columnConfigChecked,
      columnConfigTemp: {},
      columnConfigVisible: false,
      // 投手报表配置
      pitcherOptionalColumnsConfig,
      pitcherColumnConfigChecked,
      pitcherColumnConfigTemp: {},
      pitcherColumnConfigVisible: false,
      summaryMap: [
        { label: '广告主数量', key: 'total_account_num' },
        { label: '总消耗', key: 'total_cost' },
        { label: '总回收', key: 'total_income' },
        { label: '总回收 ROI', key: 'total_income_roi' },
        { label: '利润', key: 'total_profit' },
        // { label: '扣点利润', key: 'total_rebate_profit' },
        // { label: '总回收扣点', key: 'total_rebate_income' },
        // { label: '总回收扣点 ROI', key: 'total_rebate_roi' },
        { label: 'ROI', key: 'total_roi' }
      ]
    }
  },
  computed: {
    // 回收报表可见列
    visibleOptionalColumns() {
      return this.optionalColumnsConfig.filter(col => this.columnConfigChecked[col.prop])
    },
    // 投手报表可见列
    visiblePitcherOptionalColumns() {
      return this.pitcherOptionalColumnsConfig.filter(col => this.pitcherColumnConfigChecked[col.prop])
    },
    // 投手报表排序后数据
    pitcherSortedTableData() {
      const { prop, order } = this.pitcherSort
      if (!prop || !order) return this.tableData2

      const data = [...this.tableData2]
      const isAsc = order === 'ascending'

      data.sort((a, b) => {
        let valA = a[prop] ?? ''
        let valB = b[prop] ?? ''

        // 数字类型排序
        if (!isNaN(Number(valA)) && !isNaN(Number(valB))) {
          valA = Number(valA)
          valB = Number(valB)
        }

        if (valA > valB) return isAsc ? 1 : -1
        if (valA < valB) return isAsc ? -1 : 1
        return 0
      })
      return data
    }
  },
  mounted() {
    const today = this.formatDate(new Date())
    this.dateRange = [today, today]
    this.parmrs.start_time = today
    this.parmrs.end_time = today
    this.init()
  },
  methods: {
    init() {
      this.list()
      this.getlist1()
      this.getlist2()
    },
    list() {
      iaaMaterialReportdepartmentlist({ page: 1, page_size: 100 }).then(res => {
        this.options = res.data.list
      })
    },
    newqwr() {
      this.parmrs.pitcher_id = ''
      iaapitcherindex({ department_id: this.parmrs.department_id }).then(res => {
        this.optionstwo = res.data.list
      })
    },
    handleDateChange(val) {
      this.parmrs.start_time = val ? val[0] : ''
      this.parmrs.end_time = val ? val[1] : ''
    },
    search() {
      this.parmrs.page = 1
      this.order_by = null
      this.pitcherSort = { prop: '', order: '' }
      this.init()
    },
    reset() {
      this.parmrs = {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: '',
        account_id: '',
        account_name: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.order_by = null
      this.pitcherSort = { prop: '', order: '' }
      this.init()
    },
    // 回收报表排序
    sortChange1({ prop, order }) {
      this.order_by = order
        ? { field: prop, order: order === 'ascending' ? 'asc' : 'desc' }
        : null
      this.parmrs.page = 1
      this.getlist1()
    },
    // 投手报表排序
    sortChange2({ prop, order }) {
      this.pitcherSort = { prop, order }
    },
    getlist1() {
      this.loading1 = true
      reportrecyclingList({ ...this.parmrs, order_by: this.order_by, select_field: Object.keys(this.columnConfigChecked) })
        .then(res => {
          this.tableData1 = res.data.list
          this.total1 = res.data.total
        })
        .finally(() => (this.loading1 = false))
    },
    getlist2() {
      this.loading2 = true
      reportpitcherList(this.parmrs)
        .then(res => {
          this.reportData = res.data
          this.tableData2 = res.data.list
        })
        .finally(() => (this.loading2 = false))
    },
    fetchCurrentPage1(p) {
      this.parmrs.page = p
      this.getlist1()
    },
    fetchPageSize1(s) {
      this.parmrs.page_size = s
      this.parmrs.page = 1
      this.getlist1()
    },
    formatDate(d) {
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },

    // ==================== 回收报表列配置 ====================
    openColumnConfig() {
      this.optionalColumnsConfig.forEach(col => {
        this.$set(this.columnConfigTemp, col.prop, this.columnConfigChecked[col.prop])
      })
      this.columnConfigVisible = true
    },
    applyColumnConfig() {
      this.optionalColumnsConfig.forEach(col => {
        this.$set(this.columnConfigChecked, col.prop, this.columnConfigTemp[col.prop])
      })
      try {
        localStorage.setItem(COLUMN_CONFIG_STORAGE_KEY, JSON.stringify(this.columnConfigChecked))
      } catch (e) {
        console.log(e)
      }
      this.columnConfigVisible = false
    },
    // ==================== 投手报表列配置 ====================
    openPitcherColumnConfig() {
      this.pitcherOptionalColumnsConfig.forEach(col => {
        this.$set(this.pitcherColumnConfigTemp, col.prop, this.pitcherColumnConfigChecked[col.prop])
      })
      this.pitcherColumnConfigVisible = true
    },
    applyPitcherColumnConfig() {
      this.pitcherOptionalColumnsConfig.forEach(col => {
        this.$set(this.pitcherColumnConfigChecked, col.prop, this.pitcherColumnConfigTemp[col.prop])
      })
      try {
        localStorage.setItem(PITCHER_COLUMN_CONFIG_STORAGE_KEY, JSON.stringify(this.pitcherColumnConfigChecked))
      } catch (e) {
        console.log(e)
      }
      this.pitcherColumnConfigVisible = false
    }
  }
}
</script>

<style scoped>
.summary-card { background:#f9fafc;margin:20px 0 }
.summary-container { display:flex;flex-wrap:wrap;gap:20px; justify-content: space-evenly; }
.summary-item { flex:0 0 140px;background:#fff;border-radius:8px;padding:10px;text-align:center }
.summary-label { color:#909399;font-size:13px }
.summary-value { font-size:20px;font-weight:600;margin-top:8px }
h3 { font-size:16px;font-weight:600 }
.column-config-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 400px;
  gap: 8px 24px;
}
.column-config-list .el-checkbox { margin-right: 0; margin-bottom: 4px; }
</style>
